import { useUser } from "@p0security/frontend-core";
import { AppPaths } from "@p0security/shared/routes/constants";
import {
  Button,
  Card,
  Col,
  Flex,
  Image,
  Space,
  Spacing,
  Typography,
} from "@p0security/ui";
import { JitPaths } from "components/Jit/paths";
import { Splash } from "components/Splash";
import { TenantAwareLink } from "components/common/TenantAwareLink";
import { Link } from "react-router-dom";

import { WelcomePaths } from "../paths";

export const SetupNotifiers: React.FC<object> = () => {
  const { orgSlug } = useUser();
  return (
    <Splash overrideColumn rowStyleOverride={{ alignItems: "center" }}>
      <Col xs={22} md={12} lg={12} xl={10}>
        <Space direction="vertical" size="large">
          <Space direction="vertical" size={0}>
            <Spacing asChild m={0}>
              <Typography.Title level={4}>
                Get started requesting access with P0
              </Typography.Title>
            </Spacing>
            <Typography.Paragraph>
              Your team can request and approve access directly through our UI.
            </Typography.Paragraph>
            <Card>
              <Flex justify="center">
                <Image
                  preview={false}
                  src="/request-modal.jpg"
                  alt="P0"
                  height={380}
                  width={480}
                />
              </Flex>
              <br />
              <br />
              <Flex align="baseline" gap="0.5em" justify="space-between" wrap>
                {/* We want to clear the search params if they go back to the start */}
                {/* nosemgrep:link-component-in-environment-folders */}
                <Link to={`/o/${orgSlug}/${WelcomePaths.Root}/`}>
                  Add Additional Resources &nbsp;
                </Link>

                <TenantAwareLink
                  to={`${AppPaths.AccessManagement}/${JitPaths.Activity}`}
                  className="no-underline"
                >
                  <Button type="primary">Take me there</Button>
                </TenantAwareLink>
              </Flex>
            </Card>
          </Space>
          {/* TODO ENG-4769: Add CLI once we have a proper screenshot or gif */}
          {/* <Space direction="vertical" size={0} className="w-full">
              <Typography.Paragraph>
                <strong>Through our CLI</strong>
              </Typography.Paragraph>
              <Card>
                Get started at&nbsp;
                <Link
                  to="https://github.com/p0-security/p0cli"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://github.com/p0-security/p0cli
                </Link>
              </Card>
            </Space> */}
          {/* TODO ENG-4281: Add Slack Install Support */}
          {/* <>
            <Typography.Paragraph>
              <strong>Through Slack</strong> Install the P0 Slack bot.
            </Typography.Paragraph>
            <Slack
              cardOverride={{ showBreadcrumbs: false, canRemove: false }}
              onStateTransition={handleFinishSlackInstall}
            />
          </> */}
          {/* TODO ENG-4769: Add email */}
          {/* TODO ENG-4820: Add teams */}
          {/* <Card title={<TeamsLogo></TeamsLogo><Typography.Title level={5}>Teams</Typography.Title>}>
              <Button type="default" disabled>
                Coming soon
              </Button>
            </Card> */}
        </Space>
      </Col>
    </Splash>
  );
};
